import Tooltip from "@mui/material/Tooltip";
import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router";
// @material-ui/core components
import {
  Checkbox,
  CircularProgress,
  Collapse,
  FormControl,
  Input,
  Link as MuiLink,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import {
  Archive,
  Delete,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Pause,
  PlayArrow,
  Refresh,
  RestoreFromTrash,
} from "@mui/icons-material";
import DragAndDrop from "../../hoc/DragAndDrop";
import * as actions from "../../store/actions";

import { formatValuta, replaceDynamicText } from "../../utils";

//core components
import CardHeader from "../Card/CardHeader";
import Card from "../Card/Card";
import CardIcon from "../Card/CardIcon";
import CardBody from "../Card/CardBody";
import CustomSwitch from "../CustomInput/CustomSwitch";
import NumberInput from "../CustomInput/NumberInput";
import TimeInput from "../CustomInput/TimeInput";
import GridItem from "../Grid/GridItem";
import Pagination from "../Table2/CustomPagination";
import Limit from "../Table2/Limit";
import GridContainer from "../Grid/GridContainer";
import Button from "../CustomButtons/Button";

import { withStyles } from "tss-react/mui";
import jamezzTableStyle from "./JamezzTableStyle";

// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import TranslationWrapper, { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import ControlledInput from "../CustomInput/ControlledInput";
import IconButton from "../../../components/Buttons/IconButton";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";
import _ from "lodash";
import { toast } from "react-toastify";

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

function prepareRowData(flatMapping, rowData) {
  let computedData;
  if (typeof flatMapping.getDataMapping === "function") {
    computedData = flatMapping.getDataMapping(rowData);
  }
  return computedData ?? flatMapping;
}

export function ValutaInput({ propKey, value, name, onChange, currency, disabled, ...otherProps }) {
  if (disabled) {
    return formatValuta(value, currency);
  }

  return (
    <NumberInput
      {...otherProps}
      currency={currency}
      inputProps={{
        style: { paddingTop: "6px" },
      }}
      key={propKey}
      name={name}
      onChange={onChange}
      type={"valuta"}
      value={value}
    />
  );
}

/*
 * props.dataMapping
 * there are three types of mapping
 *   defining custom data for your row, has access to row data
 *   { "customData": fn(row) }
 *   property mapping, get a property
 *   You can define additional static values here. Such as "editable: <bool>"
 *   { "dbfield": <string>yourdbfield, <..kv> }
 *   relation mapping
 *   Just like with property mapping, additional static values can be defined here.
 *   { "dbfield": <string>yourrelation.relationdbfield, <..kv> }
 */

export function SwitchInput({ key, naam, value, onChange, disabled, tKey = undefined, tDefault = undefined }) {
  let title = "";
  if (tKey && tDefault) {
    title = getTranslation(tKey, tDefault);
  }
  if (disabled) {
    return (
      <Tooltip title={title}>
        <div>
          <Checkbox checked={value} disabled />
        </div>
      </Tooltip>
    );
  }
  return <CustomSwitch checked={value} disabled={disabled} key={key} name={naam} onChange={onChange} value={value} />;
}

class JamezzTable extends React.Component {
  //Default state
  state = {
    loading: true,
    needsRefresh: false,
    saving: false,

    items: [],

    total_items: 0,
    total_pages: 1,

    // last_page_before_filtering: 1,

    headers: [...this.props.headers],

    selectedIds: [],

    autoRenew: false,
    autoRenewTime: 30000, //30 seconden

    deletePopup: false,
    deleteId: null,

    showArchive: false,

    restorePopup: false,
    restoreId: null,

    collapse: !!(this.props.renderCollapse ?? false),
    popupCss: this.props.popupCss ?? {},
    collapseObj: {},
    nextPageCursor: null,
    prevPageCursor: null,
  };

  //Current Request data
  currentRequestUrl;
  currentRequestField;

  //AutoRenew
  intervalID;

  typingTimer = {};

  /*
      | Refresh table data.
      | Note:
      | This function is called from a lot of other classes.
      | Don't remove without changing all calls.
      */
  refreshData = () => {
    this.getData();
  };

  getData = async () => {
    this.setState({ loading: true });

    try {
      const response = await this.getAxiosUrl();

      let tableData = this.convertDbDataToTableData(response.data.data.data);

      let nextPageCursor;
      if (response.data.data.next_page_url) {
        const next_page = new URL(response.data.data.next_page_url);
        nextPageCursor = next_page.searchParams.get("cursor");
      }
      let prevPageCursor;
      if (response.data.data.prev_page_url) {
        const prev_page = new URL(response.data.data.prev_page_url);
        prevPageCursor = prev_page.searchParams.get("cursor");
      }

      if (prevPageCursor && this.props.current_page === 1) {
        this.props.setCurrentPage(2);
      } else if (response.data.data.total == null && !prevPageCursor && this.props.current_page > 1) {
        this.props.setCurrentPage(1);
      }
      this.setState({
        nextPageCursor,
        prevPageCursor,
        items: tableData,
        itemsRaw: response.data.data.data,
        total_items: response.data.data.total,
        total_pages: response.data.data.last_page,
        loading: false,
      });
    } catch (error) {
      this.setState({
        items: [],
        total_items: 1,
        total_pages: 1,
        loading: false,
      });
    } finally {
      /**
       * Autorenew timout reseten en als die aanstaat opnieuw zetten
       */
      clearTimeout(this.intervalID);
      if (this.state.autoRenew) {
        this.intervalID = setTimeout(() => this.getData(), this.state.autoRenewTime);
      }
    }
  };

  getAxiosUrl = () => {
    // Als er nog een request loopt die annuleren
    if (this.currentRequest) {
      this.currentRequest.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;

    if (this.props.filters === undefined || Object.entries(this.props.filters).length === 0) {
      const url = this.props.fetchUrl;

      return axios({
        url: url + this.getUrlQuery(url),
        method: "get",
        cancelToken: cancelToken,
      });
    } else {
      let url = this.props.searchUrl ? this.props.searchUrl : this.props.fetchUrl + "/search";

      if (url.includes("?") && url.endsWith("/search") && url.split("?").length === 2) {
        url = url.replace("/search", "").split("?");
        url = url[0] + "/search" + "?" + url[1];
      }

      return axios({
        url: url + this.getUrlQuery(url),
        method: "post",
        data: this.props.filters,
        cancelToken: cancelToken,
      });
    }
  };

  getUrlQuery(startUrl) {
    const hasQueryParams = startUrl.includes("?");

    let query_data = [];

    query_data.push("per_page=" + this.props.per_page);

    if (this.props.current_page !== 1) {
      query_data.push("page=" + this.props.current_page);
    }

    if (this.props.ordering.key !== null && this.props.ordering.direction !== null) {
      query_data.push("sort_field=" + this.props.ordering.key);
      query_data.push("sort_dir=" + this.props.ordering.direction);
    }
    if (this.props.ordering.sortType) {
      query_data.push("sort_type=" + this.props.ordering.sortType);
    }

    if (this.props.dbfields !== undefined) {
      if (Array.isArray(this.props.dbfields)) {
        query_data.push("fields=" + this.props.dbfields.join());
      } else {
        query_data.push("fields=" + this.props.dbfields);
      }
    }
    if (this.state.cursor) {
      query_data.push("cursor=" + this.state.cursor);
    }

    let queryString = "";

    /**
     * Als archive dan deleted = true toevoegen
     */
    if (this.state.showArchive === true) {
      query_data.push("deleted=true");
    }

    query_data.map((item, key) => {
      queryString = queryString + (key === 0 && !hasQueryParams ? "?" : "&") + item;
    });

    return queryString;
  }

  /*
   * Converts data from the backend to data appropriate for rendering the table
   * JamezzTable.props.dataMapping defines how to map a given row to data appropriate for rendering
   */
  convertDbDataToTableData = (dbdata) => {
    const mappingHasRelationData = (mapping) => mapping.dbfield.includes(".");
    const mappingHasCustomData = (mapping) => mapping.customData !== undefined;
    const isRelationTypeHasMany = (relationData) => typeof relationData === "object" && Array.isArray(relationData);

    return dbdata.map((rowdata) => {
      return this.props.dataMapping.map((mapping) => {
        // custom mapping <"customData": fn(row)>
        if (mappingHasCustomData(mapping)) {
          return mapping.customData(rowdata);
        }

        // a relation can either contain a single object (hasOne)
        // or an array of objects (hasMany)
        if (mappingHasRelationData(mapping)) {
          let [relation, dbfield] = mapping.dbfield.split(".");
          const relationData = rowdata[relation];

          if (isRelationTypeHasMany(relationData)) {
            // hasMany mapping <"relation.field": <object>>
            return relationData.map((rd) => rd[dbfield]);
          }

          // hasOne mapping <"relation.dbfield": <object>>
          return _.get(rowdata, mapping.dbfield);
        }

        // regular mapping <dbfield: value>
        return rowdata[mapping.dbfield];
      });
    });
  };

  convertTableData = (prop, key, rowKey, rowProp) => {
    const { classes } = this.props;

    let tableCellData;

    const namedRows = {};
    this.props.dataMapping.forEach(({ dbfield }, idx) => {
      namedRows[dbfield ?? "customData"] = rowProp[idx];
    });
    const dataMapping = prepareRowData(this.props.dataMapping[key], namedRows);

    if (dataMapping.customRender !== undefined) {
      let customRender = dataMapping.customRender.bind(this);
      tableCellData = customRender(prop, key, rowKey, rowProp);
    } else {
      let naam = dataMapping.dbfield;

      switch (dataMapping.inputtype) {
        case "Input":
          let inputProps = {};

          if (dataMapping.dbfield === "naam") {
            inputProps = {
              style: { minWidth: "150px" },
            };
          }

          tableCellData = (
            <Input
              fullWidth={true}
              inputProps={inputProps}
              key={rowProp[0]}
              name={naam}
              onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.target.value, WAIT_INTERVAL)}
              style={{ backgroundColor: "rgba(100, 100, 100, 0.05)" }}
              value={prop ?? ""}
            />
          );

          break;
        case "Switch":
          tableCellData = (
            <SwitchInput
              disabled={!dataMapping.editable}
              disabled_explanation_tDefault={dataMapping.disabled_explanation_tDefault ?? ""}
              disabled_explanation_tKey={dataMapping.disabled_explanation_tKey ?? ""}
              key={rowProp[0]}
              name={naam}
              onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.target.checked)}
              value={prop}
            />
          );
          break;
        case "Checkbox":
          tableCellData = (
            <Checkbox
              checked={prop}
              disabled={dataMapping.disabled ?? false}
              key={rowProp[0]}
              name={naam}
              onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.target.checked)}
              value={prop}
            />
          );
          break;
        case "Number":
          tableCellData = (
            <NumberInput
              inputProps={{
                style: { paddingTop: "6px" },
              }}
              key={rowProp[0]}
              name={naam}
              onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.value, WAIT_INTERVAL)}
              value={prop}
              {...dataMapping.inputProps}
            />
          );

          break;
        case "Valuta":
          const onChange = (e) => this.updateDataValuta(rowKey, key, naam, rowProp[0], e, WAIT_INTERVAL);
          tableCellData = (
            <ValutaInput
              currency={prop.currency}
              disabled={!dataMapping.editable}
              name={naam}
              onChange={onChange}
              propKey={rowProp[0]}
              value={prop.value}
            />
          );

          break;
        case "Link":
          let urlData = { ...dataMapping.urlData };
          let noUrl = false;
          Object.keys(urlData).forEach((field) => {
            let index = this.props.dataMapping.findIndex((dataMap) => dataMap.dbfield === urlData[field]);
            if (index < 0) {
              noUrl = true;
            }
            urlData[field] = rowProp[index];
            if (rowProp[index] == null) {
              noUrl = true;
            }
          });

          tableCellData = noUrl ? (
            <Typography>-</Typography>
          ) : (
            <MuiLink
              color={"primary"}
              component={Link}
              key={rowProp[0]}
              to={replaceDynamicText(urlData, dataMapping.url)}
              underline={"always"}
            >
              {prop}
            </MuiLink>
          );

          break;
        case "ControlledInput":
          tableCellData = (
            <ControlledInput
              inputProps={dataMapping.inputProps}
              key={rowProp[0]}
              name={naam}
              nullable={!!dataMapping.nullable}
              onHandleValue={(value) => this.updateData(rowKey, key, naam, rowProp[0], value)}
              type={dataMapping.type}
              value={prop}
            />
          );
          break;
        case "Time":
          tableCellData = (
            <TimeInput
              key={rowProp[0]}
              name={naam}
              onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.target.value)}
              value={prop ? prop : ""}
            />
          );
          break;
        case "Async":
          const async_props = {};
          if (dataMapping.placeholder) {
            async_props.placeholder = dataMapping.placeholder;
          }
          if (dataMapping.multiple) {
            async_props.multiple = dataMapping.multiple;
          }
          if (dataMapping.defaultValue) {
            async_props.defaultValue = dataMapping.defaultValue;
          }
          if (dataMapping.value) {
            async_props.value = dataMapping.value;
          }
          const autocompleteEl = (
            <AsynchronousAutocomplete
              async={dataMapping.async}
              key={rowProp[0]}
              onChange={(_, option) => {
                // this option only when is multi
                if (Array.isArray(option) && dataMapping.multiple) {
                  this.updateData(
                    rowKey,
                    key,
                    naam,
                    rowProp[0],
                    option.map((o) => o.value)
                  );
                } else if (option) {
                  this.updateData(rowKey, key, naam, rowProp[0], option.value);
                  if (dataMapping.onChange) {
                    dataMapping.onChange(this, option, rowKey);
                  }
                } else {
                  this.updateData(rowKey, key, naam, rowProp[0], dataMapping.nullValue ?? null);
                  if (dataMapping.onChange) {
                    dataMapping.onChange(this, option, rowKey);
                  }
                }
              }}
              {...async_props}
            />
          );
          if (dataMapping.titleOnHover) {
            let title = getTranslation(dataMapping.titleOnHover.tKey, dataMapping.titleOnHover.tDefault);
            tableCellData = (
              <Tooltip title={title}>
                <div>{autocompleteEl}</div>
              </Tooltip>
            );
          } else {
            tableCellData = autocompleteEl;
          }
          break;
        case "Dropdown":
          tableCellData = (
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: dataMapping.dbfield,
                }}
                key={rowProp[0]}
                onChange={(e) => this.updateData(rowKey, key, naam, rowProp[0], e.target.value)}
                style={{ backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                value={prop}
              >
                {this.props.inputValues[dataMapping.inputvalue].map((prop, key) => {
                  return (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      key={key}
                      value={prop.id}
                    >
                      {prop.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          );

          break;
        case "Image":
          let url = "/img/nophoto.png";
          if (prop !== null) {
            //als data string is
            if (typeof prop === "string" && prop.startsWith("data")) {
              url = prop;
            } else if (typeof prop === "string" && prop.startsWith("http")) {
              url = prop;
            } else if (typeof prop === "object" && Array.isArray(prop) && prop.length > 0) {
              url =
                prop[0].conversions?.["height_50"]?.url ?? prop[0].conversions?.["height_200"]?.url ?? prop[0].original;
            }
          }
          tableCellData = (
            <DragAndDrop
              handleDrop={(file) =>
                this.uploadData(
                  rowKey,
                  key,
                  this.props.legacy == undefined || this.props.legacy
                    ? (dataMapping.postField ?? naam)
                    : "img_uuids__uuid[0]",
                  rowProp[0],
                  file[0]
                )
              }
              key={rowProp[0]}
            >
              <div align={"center"} style={{ width: "60px" }}>
                <img
                  alt={"afbeelding"}
                  sizes={"50px"}
                  src={url}
                  srcSet={typeof prop === "object" ? prop?.[0]?.conversions?.responsive?.srcset : undefined}
                  style={{ maxWidth: "50px", maxHeight: "50px" }}
                />
              </div>
            </DragAndDrop>
          );
          break;
        default:
          tableCellData = prop;
          break;
      }
    }

    return tableCellData;
  };

  updateData = (rowIndex, cellIndex, field, itemId, value, timeout = false) => {
    if (!this.typingTimer[rowIndex]) {
      this.typingTimer[rowIndex] = {};
    }
    //vorige request timeout annuleren
    if (this.typingTimer[rowIndex][cellIndex]) {
      clearTimeout(this.typingTimer[rowIndex][cellIndex]);
    }

    /**
     * Als de state het zelfde is als de value bijvoorbeeld bij zelfde dropdown item selecteren niks doen.
     */
    if (this.state.items[rowIndex][cellIndex] === value) {
      return true;
    }

    //State update met nieuwe value moet meteen zodat het aanvoelt dat je gewoon zonder vertraging
    let newItems = [...this.state.items];
    newItems[rowIndex][cellIndex] = value;
    this.setState({ items: newItems });

    //Als er een specefieke patch url gegeven is dan die gebruiken anders fetch url pakken
    //99% van de gevalen is dit het geval maar er zijn altijd uitzonderingen
    let url = this.props.patchUrl ? this.props.patchUrl : this.props.fetchUrl;

    if (url.includes("?") && url.split("?").length === 2) {
      url = url.split("?");
      url = url[0] + "/" + itemId + "?" + url[1];
    } else {
      url = url + "/" + itemId;
    }

    let data = { [field]: value };

    /**
     * Als er een zefde request is deze annuleren
     */
    if (this.currentRequest !== undefined && this.currentRequestUrl === url && this.currentRequestField === field) {
      this.currentRequest.cancel();
    }

    //Deze losse functie stoppen dan kan ik er een timout op geven
    this.typingTimer[rowIndex][cellIndex] = setTimeout(
      () => this.updateDataDoRequest(url, data, field, itemId),
      timeout
    );
  };

  /**
   * HACKY
   */
  updateDataValuta = (rowIndex, cellIndex, field, itemId, value, timeout = false) => {
    //vorige request timeout annuleren
    if (!this.typingTimer) {
      this.typingTimer = [];
    }
    if (!this.typingTimer[rowIndex]) {
      this.typingTimer[rowIndex] = [];
    }

    if (this.typingTimer[rowIndex][cellIndex]) {
      clearTimeout(this.typingTimer[rowIndex][cellIndex]);
    }

    /**
     * Als de state het zelfde is als de value bijvoorbeeld bij zelfde dropdown item selecteren niks doen.
     */
    if (this.state.items[rowIndex][cellIndex] === value) {
      return true;
    }

    //State update met nieuwe value moet meteen zodat het aanvoelt dat je gewoon zonder vertraging
    let newItems = [...this.state.items];
    newItems[rowIndex][cellIndex] = value;
    this.setState({ items: newItems });

    //Als er een specefieke patch url gegeven is dan die gebruiken anders fetch url pakken
    //99% van de gevalen is dit het geval maar er zijn altijd uitzonderingen
    let url = this.props.patchUrl ? this.props.patchUrl : this.props.fetchUrl;
    url = url + "/" + itemId;

    let data = { [field]: value.value };

    /**
     * Als er een zefde request is deze annuleren
     */
    if (this.currentRequest !== undefined && this.currentRequestUrl === url && this.currentRequestField === field) {
      this.currentRequest.cancel();
    }

    //Deze losse functie stoppen dan kan ik er een timout op geven
    this.typingTimer[rowIndex][cellIndex] = setTimeout(() => this.updateDataDoRequest(url, data, field), timeout);
  };

  updateDataDoRequest = (url, data, field, itemId = null) => {
    this.setState({ saving: true });

    //Variable om de nieuwe request te annuleren
    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;
    this.currentRequestUrl = url;
    this.currentRequestField = field;

    axios
      .patch(url, data, {
        cancelToken: cancelToken,
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Fout bij opslaan");
        }

        this.setState({ saving: false });
      })
      .then((res) => {
        if ("onUpdateSuccess" in this.props) {
          const row = this.state.items.filter((item) => item[0] === itemId);

          this.props.onUpdateSuccess(row[0] ?? null, data);
        }
        this.setState({ saving: false });
      });
  };

  uploadData = (rowIndex, cellIndex, field, itemId, value) => {
    this.setState({ saving: true });

    //Als er een specefieke patch url gegeven is dan die gebruiken anders fetch url pakken
    //99% van de gevalen is dit het geval maar er zijn altijd uitzonderingen
    let url = this.props.patchUrl ? this.props.patchUrl : this.props.fetchUrl;
    url = url + "/" + itemId;

    let data = new FormData();
    data.append(field, value);
    data.append("_method", "PATCH");

    if (this.currentRequest !== undefined && this.currentRequestUrl === url && this.currentRequestField === field) {
      this.currentRequest.cancel();
    }

    //Variable om te annuleren
    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;
    this.currentRequestUrl = url;
    this.currentRequestField = field;

    //State update
    let reader = new FileReader();
    reader.onloadend = () => {
      let newItems = [...this.state.items];
      newItems[rowIndex][cellIndex] = reader.result;
      this.setState({ items: newItems });
    };

    reader.readAsDataURL(value);

    axios
      .post(url, data, {
        cancelToken: cancelToken,
      })
      .then((res) => {
        this.setState({ saving: false });
      })
      .catch((error) => {
        toast.warn("Fout bij opslaan");
        this.setState({ saving: false });
      });
  };

  //Component functies
  componentDidMount() {
    if (this.props.reduxKey !== this.props.current_table) {
      this.props.setCurrentTable(this.props.reduxKey);
    } else {
      this.getData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const needsRefreshData = ["per_page", "current_page", "ordering", "current_table"];

    let refreshData = false;

    needsRefreshData.forEach((item) => {
      if (this.props[item] !== prevProps[item]) {
        refreshData = true;
      }
    });

    if (JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters)) {
      this.props.setCurrentPage(1);
      this.setState({ cursor: null, nextPageCursor: null, prevPageCursor: null });
      refreshData = true;
    }

    if (this.state.showArchive !== prevState.showArchive) {
      refreshData = true;
    }

    if (refreshData) {
      this.debounce();
    }

    if (this.state.selectedIds !== prevState.selectedIds) {
      if (this.props.multieSelectHandler !== undefined) {
        this.props.multieSelectHandler(this.state.selectedIds);
      }
    }
  }

  debounce = _.debounce(() => {
    this.getData();
  }, 600);

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentRequest !== undefined) {
      this.currentRequest.cancel();
    }

    /**
     * Time out clearen van de eventuele autorefresh
     */
    clearTimeout(this.intervalID);
  }

  //Ordering functies
  headerClickHandler(sortKey, sortType = "alphabetically") {
    //Current data
    const currentDirection = this.props.ordering.key === sortKey ? this.props.ordering.direction : null;

    //New direction
    let newDirection = null;

    switch (currentDirection) {
      case null:
        newDirection = "asc";
        break;
      case "asc":
        newDirection = "desc";
        break;
      case "desc":
        newDirection = null;
        break;
    }

    this.props.setOrdering({
      key: sortKey,
      direction: newDirection,
      sortType: sortType,
    });
  }

  renderSortKeyIcon() {
    switch (this.props.ordering.direction) {
      case "asc":
        return <KeyboardArrowUp />;
      case "desc":
        return <KeyboardArrowDown />;
      default:
        return null;
    }
  }

  //Pagnation & Limit
  handlePagination = (page, next) => {
    // if (Object.keys(this.props.filters).length === 0) {
    //   this.setState({ last_page_before_filtering: page });
    // }

    let cursor = null;
    if (next === "next") {
      cursor = this.state.nextPageCursor;
    } else {
      cursor = this.state.prevPageCursor;
    }
    this.setState({ collapseObj: {}, cursor });
    this.props.setCurrentPage(page);
  };

  handleLimit = (value) => {
    this.props.setPerPage(value);
  };

  //Multieselect handler
  setSelectedIds = (id, checked = true) => {
    let newSelectedIds = [...this.state.selectedIds];

    if (checked) {
      newSelectedIds.push(id);
    } else {
      let indexKey = newSelectedIds.indexOf(id);
      newSelectedIds.splice(indexKey, 1);
    }

    this.setState({ selectedIds: newSelectedIds });
  };

  toggleAutoRenew = () => {
    if (!this.state.autoRenew) {
      this.intervalID = setTimeout(() => this.getData(), this.state.autoRenewTime);
    } else {
      clearTimeout(this.intervalID);
    }

    this.setState({
      autoRenew: !this.state.autoRenew,
    });
  };

  //Helper functies
  convertDataMappingToKeyArray = (row) => {
    const needles = {};
    this.props.dataMapping.forEach((item, key) => {
      needles[item.dbfield] = row[key];
    });
    return needles;
  };

  //Render
  renderEdit(id) {
    const { classes } = this.props;

    let needles = {
      id: id,
    };

    let editLink = replaceDynamicText(needles, this.props.editLink);

    return (
      <AuthenticationWrapper permissionKey={this.props.editLinkPermission ?? this.props.editLink}>
        <Link to={editLink}>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <Button className={classes.actionButton} color={"success"} simple>
              <Edit className={classes.icon} />
            </Button>
          </Tooltip>
        </Link>
      </AuthenticationWrapper>
    );
  }

  /**
   * Render Delete or restore butten
   */
  renderDeleteRestore(needles) {
    const { classes } = this.props;
    const id = needles.id;
    const hideDelete =
      Object.hasOwn(needles, "is_archivable") &&
      needles.is_archivable === false &&
      needles?.["vestiging.apiProvider"] != null &&
      needles?.["vestiging.apiProvider"] != "JAMEZZ";

    return (
      <AuthenticationWrapper permissionKey={this.props.delete}>
        {this.state.showArchive ? (
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Herstel"} tKey={"global.jamezzTable.restore"} />}
          >
            <Button className={classes.actionButton} color={"success"} onClick={() => this.showRestorePopup(id)} simple>
              <RestoreFromTrash className={classes.icon} />
            </Button>
          </Tooltip>
        ) : hideDelete ? (
          <></>
        ) : (
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.jamezzTable.remove"} />}
          >
            <Button className={classes.actionButton} color={"danger"} onClick={() => this.showDeletePopup(id)} simple>
              <Delete className={classes.icon} />
            </Button>
          </Tooltip>
        )}
      </AuthenticationWrapper>
    );
  }

  renderActions = (row, rawRow) => {
    const { classes } = this.props;
    const needles = this.convertDataMappingToKeyArray(row);
    return (
      <TableCell align={"right"} padding={"none"}>
        {!this.state.showArchive && this.props.actions
          ? this.props.actions
              .filter((action) => {
                if (action.show) {
                  return action.show(row);
                } else {
                  return true;
                }
              })
              .map((prop, key) => {
                let action = null;
                switch (prop.actionType) {
                  case "link":
                    action = (
                      <Link key={key} to={replaceDynamicText(needles, prop.action)}>
                        <Tooltip classes={{ tooltip: classes.tooltip }} placement={"bottom"} title={prop.tooltip}>
                          <Button className={classes.actionButton} color={"success"} simple>
                            <prop.icon className={classes.icon} />
                          </Button>
                        </Tooltip>
                      </Link>
                    );
                    break;
                  case "download":
                    action = (
                      <Link download key={key} target={"_blank"} to={replaceDynamicText(needles, prop.action)}>
                        <Tooltip classes={{ tooltip: classes.tooltip }} placement={"bottom"} title={prop.tooltip}>
                          <Button className={classes.actionButton} color={"success"} simple>
                            <prop.icon className={classes.icon} />
                          </Button>
                        </Tooltip>
                      </Link>
                    );
                    break;
                  case "component":
                    action = (
                      <AuthenticationWrapper
                        child={React.cloneElement(prop.render, { row: row })}
                        key={key}
                        permissionKey={prop.permissionKey}
                      />
                    );
                    break;
                  case "action":
                  default:
                    if (prop?.activeField) {
                      if (rawRow[prop?.activeField] == undefined || rawRow[prop?.activeField] == null) {
                        action = null;
                        break;
                      }
                    }

                    action = (
                      <AuthenticationWrapper
                        child={
                          <Tooltip
                            classes={{ tooltip: classes.tooltip }}
                            key={key}
                            placement={"bottom"}
                            title={prop.tooltip}
                          >
                            <Button
                              className={classes.actionButton}
                              color={"success"}
                              onClick={() => prop.action(row, rawRow)}
                              simple
                            >
                              <prop.icon className={classes.icon} />
                            </Button>
                          </Tooltip>
                        }
                        key={key}
                        permissionKey={prop.permissionKey}
                      />
                    );

                    break;
                }

                return action;
              })
          : null}

        {/*STANDAARD EDIT KNOP*/}
        {!this.state.showArchive && this.props.editLink ? this.renderEdit(needles.id) : null}
        {this.props.delete ? this.renderDeleteRestore(needles) : null}
      </TableCell>
    );
  };

  renderSelect = (row) => {
    const { classes } = this.props;
    const data = this.convertDataMappingToKeyArray(row);
    const selected = this.state.selectedIds.includes(data.id);

    return this.props.multieSelect ? (
      <TableCell className={classes.tableCell}>
        <Checkbox
          checked={selected}
          color={"primary"}
          onChange={(e) => this.setSelectedIds(data.id, e.target.checked)}
        />
      </TableCell>
    ) : null;
  };

  /**
   * Handler voor de multie select checkbox
   */
  handleAllSelect = (event) => {
    if (event.target.checked) {
      let selectedIds = [];
      this.state.items.forEach((item, key) => {
        const mapping = this.convertDataMappingToKeyArray(item);
        selectedIds.push(mapping.id);
      });

      this.setState({ selectedIds: selectedIds });
    } else {
      this.setState({ selectedIds: [] });
    }
  };

  refreshData = () => this.getData();

  /**
   * Render de multiselect header
   */
  renderMultieSelectHeader = () => {
    const { classes } = this.props;

    return this.props.multieSelect ? (
      <TableCell className={classes.tableCell}>
        <Checkbox checked={this.state.selectedIds.length > 0} color={"primary"} onChange={this.handleAllSelect} />
      </TableCell>
    ) : null;
  };

  /**
   * Delete popup
   */
  showDeletePopup = (id) => {
    this.setState({
      deleteId: id,
      deletePopup: true,
    });
  };

  hideDeletePopup = () => {
    this.setState({
      deleteId: null,
      deletePopup: false,
    });
  };

  handleDelete = () => {
    const deleteUrl = this.props.fetchUrl + "/" + this.state.deleteId;

    axios
      .delete(deleteUrl)
      .then((response) => {
        if (response.data.data.success) {
          toast.success("Item goed verwijderd");
        } else {
          toast.error("Fout bij verwijderen");
        }
      })
      .catch((error) => {
        toast.error("Fout bij verwijderen");
      })
      .finally(() => {
        this.getData();
        this.hideDeletePopup();
      });
  };

  toggleShowArchive = () => {
    this.setState({
      showArchive: !this.state.showArchive,
      selectedIds: [],
    });
  };

  /**
   * Restore popup
   */
  showRestorePopup = (id) => {
    this.setState({
      restoreId: id,
      restorePopup: true,
    });
  };

  hideRestorePopup = () => {
    this.setState({
      restoreId: null,
      restorePopup: false,
    });
  };

  handleRestore = () => {
    const deleteUrl = this.props.fetchUrl + "/" + this.state.restoreId + "/restore";

    axios
      .delete(deleteUrl)
      .then((response) => {
        if (response.data.data.success) {
          toast.success("Item goed hersteld");
        } else {
          toast.error("Fout bij herstellen");
        }
      })
      .catch((error) => {
        toast.error("Fout bij herstellen");
      })
      .finally(() => {
        this.hideRestorePopup();
        this.getData();
      });
  };

  handleClick = (rowKey) => {
    if (!this.state.collapse) {
      return;
    }

    let collapseObj = this.state.collapseObj;

    if (!collapseObj[rowKey]) {
      collapseObj[rowKey] = true;
    } else {
      delete collapseObj[rowKey];
    }

    this.setState({
      collapseObj: collapseObj,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Card>
        {/*DELETE CONFIRM POPUP*/}
        {this.state.deletePopup ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.hideDeletePopup}
            onConfirm={this.handleDelete}
            showCancel
            style={{ ...this.state.popupCss, display: "block", marginTop: "-100px" }}
            title={
              <TranslationWrapper
                tDefault={"Verwijderen? Weet je het zeker?"}
                tKey={"global.jamezztable.confirm.delete"}
              />
            }
            warning
          />
        ) : null}
        {this.state.restorePopup ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.hideRestorePopup}
            onConfirm={this.handleRestore}
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <TranslationWrapper
                tDefault={"Terugzetten? Weet je het zeker?"}
                tKey={"global.jamezztable.confirm.restore"}
              />
            }
            warning
          />
        ) : null}
        {this.state.loading ? (
          <div className={classes.loadingMain}>
            <CircularProgress className={classes.loadingIcon} />
          </div>
        ) : null}
        <CardHeader color={"primary"} icon>
          <CardIcon color={"primary"}>
            {this.state.saving ? <CircularProgress size={30} style={{ color: "white" }} /> : this.props.headerIcon}
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{this.props.tableTitle}</h4>
        </CardHeader>
        <CardBody>
          <div className={classes.tableResponsive}>
            <Table className={classes.table}>
              <colgroup>
                {this.props.multieSelect ? <col width={"auto"} /> : null}
                {this.state.headers.map((prop, key) => {
                  return prop.width ? <col key={key} width={prop.width} /> : <col key={key} width={"auto"} />;
                })}

                {/*ACTION BUTTONS*/}
                {this.props.editLink || this.props.actions ? <col width={"auto"} /> : null}
              </colgroup>

              <TableHead className={classes.tableRowHead}>
                <TableRow className={classes.tableRowHead}>
                  {this.renderMultieSelectHeader()}

                  {this.state.collapse ? <TableCell /> : null}

                  {this.state.headers.map((prop, key) => {
                    return prop.sortable ? (
                      <AuthenticationWrapper
                        child={
                          <TableCell
                            className={
                              classes.tableHeadFontSize +
                              " " +
                              classes.tableHeadCell +
                              " " +
                              classes.tableCell +
                              " " +
                              classes.sortable
                            }
                            key={key}
                            onClick={() => this.headerClickHandler(prop.sortKey, prop.sortType)}
                          >
                            {typeof prop.label === "object" ? (
                              prop.label
                            ) : (
                              // TODO <LB>: Why is dangerous necessary here?
                              <span dangerouslySetInnerHTML={{ __html: prop.label }} />
                            )}
                            {this.props.ordering.key === prop.sortKey ? this.renderSortKeyIcon() : null}
                          </TableCell>
                        }
                        key={"authWrapper" + key}
                        permissionKey={prop.permissionKey}
                      />
                    ) : (
                      <AuthenticationWrapper
                        child={
                          <TableCell
                            className={
                              classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell
                            }
                            key={key}
                          >
                            {typeof prop.label === "object" ? (
                              prop.label
                            ) : (
                              // TODO <LB>: Why is it necessary to use dangerous here?
                              <span dangerouslySetInnerHTML={{ __html: prop.label }} />
                            )}
                          </TableCell>
                        }
                        key={"authWrapper" + key}
                        permissionKey={prop.permissionKey}
                      />
                    );
                  })}
                  {this.props.editLink || this.props.actions ? <TableCell /> : null}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.state.items.map((rowProp, rowKey) => {
                  let rowStyles = null;
                  if (
                    this.props.rowConditionalStyle !== undefined &&
                    typeof this.props.rowConditionalStyle === "function"
                  ) {
                    rowStyles = this.props.rowConditionalStyle(this.state.itemsRaw[rowKey]);
                  }
                  return (
                    <>
                      <TableRow className={classes.tableRow} key={rowKey} style={rowStyles}>
                        {this.renderSelect(rowProp)}
                        {rowProp.reduce((columns, prop, key) => {
                          if (this.props.dataMapping[key].hide) {
                            return columns;
                          }
                          let data = this.convertTableData(prop, key, rowKey, rowProp);

                          if (this.state.collapse && !columns.length) {
                            columns.push(
                              <TableCell className={classes.tableCell} key={key + "-collapse"}>
                                <IconButton
                                  aria-label={"expand row"}
                                  onClick={() => {
                                    this.handleClick(rowKey);
                                  }}
                                  size={"small"}
                                >
                                  {this.state.collapseObj[rowKey] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                </IconButton>
                              </TableCell>
                            );
                          }

                          columns.push(
                            <AuthenticationWrapper
                              child={
                                <TableCell className={classes.tableCell} key={key}>
                                  {typeof data === "object" ? (
                                    data
                                  ) : (
                                    // TODO <LB>: Why is it necessary to dangerouslySetInnerHTML here?
                                    <span dangerouslySetInnerHTML={{ __html: data }} />
                                  )}
                                </TableCell>
                              }
                              key={"authWrapper" + key}
                              permissionKey={this.props.dataMapping[key].permissionKey}
                            />
                          );

                          return columns;
                        }, [])}
                        {this.props.editLink || this.props.actions
                          ? this.renderActions(rowProp, this.state.itemsRaw[rowKey])
                          : null}
                      </TableRow>
                      {this.state.collapse ? (
                        <TableRow key={rowKey + "-collapsed"}>
                          <TableCell colSpan={99} style={{ padding: "0px" }}>
                            <Collapse in={this.state.collapseObj[rowKey]} timeout={"auto"} unmountOnExit>
                              <div style={{ padding: "16px" }}>
                                {this.props.renderCollapse(
                                  this.state.itemsRaw.filter((item) => item.id === rowProp[0])
                                )}
                              </div>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      ) : null}
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          <GridContainer>
            <GridItem lg={3} md={3} sm={12} xs={12}>
              {this.props.showRefresh ? (
                <Tooltip classes={{ tooltip: classes.tooltip }} placement={"bottom"} title={"Refresh table"}>
                  <Button
                    className={classes.refreshButton}
                    color={"primary"}
                    justIcon
                    onClick={this.getData}
                    size={"sm"}
                  >
                    <Refresh className={classes.icons} />
                  </Button>
                </Tooltip>
              ) : null}

              {this.props.showAutoRenew ? (
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  placement={"bottom"}
                  title={this.state.autoRenew ? "Pauze automatisch vernieuwen" : "Automatisch vernieuwen"}
                >
                  <Button
                    className={classes.renewButton}
                    color={"primary"}
                    justIcon
                    onClick={this.toggleAutoRenew}
                    size={"sm"}
                  >
                    {this.state.autoRenew ? (
                      <Pause className={classes.icons} />
                    ) : (
                      <PlayArrow className={classes.icons} />
                    )}
                  </Button>
                </Tooltip>
              ) : null}

              {this.props.delete ? (
                <AuthenticationWrapper permissionKey={this.props.delete}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement={"bottom"}
                    title={
                      this.state.showArchive ? (
                        <TranslationWrapper
                          tDefault={"Laat normale items zien"}
                          tKey={"global.jamezz.table.hideArchive"}
                        />
                      ) : (
                        <TranslationWrapper tDefault={"Laat archief zien"} tKey={"global.jamezz.table.showArchive"} />
                      )
                    }
                  >
                    <Button
                      className={classes.renewButton}
                      color={this.state.showArchive ? "success" : "primary"}
                      justIcon
                      onClick={this.toggleShowArchive}
                      size={"sm"}
                    >
                      <Archive className={classes.icons} />
                    </Button>
                  </Tooltip>
                </AuthenticationWrapper>
              ) : null}
            </GridItem>
            <GridItem className={classes.paginationGridItem} lg={6} md={6} sm={12} xs={12}>
              <Pagination
                current_page={this.props.current_page}
                nextPageCursor={this.state.nextPageCursor}
                onClick={this.handlePagination}
                prevPageCursor={this.state.prevPageCursor}
                total_pages={this.state.total_pages}
              />
            </GridItem>
            <GridItem lg={3} md={3} sm={12} xs={12}>
              <Limit onChange={this.handleLimit} selected={this.props.per_page} />
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    per_page: state.jamezztable.per_page,
    ordering: state.jamezztable.ordering,
    current_page: state.jamezztable.current_page,
    current_table: state.jamezztable.current_table,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPerPage: (per_page) => dispatch({ type: actions.SET_PER_PAGE, per_page: per_page }),
    setOrdering: (ordering) => dispatch({ type: actions.SET_ORDERING, ordering: ordering }),
    setCurrentPage: (current_page) => dispatch({ type: actions.SET_CURRENT_PAGE, current_page: current_page }),
    setCurrentTable: (current_table) => dispatch({ type: actions.SET_CURRENT_TABLE, current_table: current_table }),
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

const options = {
  forwardRef: true,
};

export default connect(mapStateToProps, mapDispatchToProps, null, options)(withStyles(JamezzTable, jamezzTableStyle));
